import { format } from 'date-fns';

const DATE_FORMATS = {
    eng: 'MM/dd/yyyy HH:mm',
    rus: 'dd.MM.yyyy HH:mm'
};

function convertUTCDateToLocalDate(date) {
    const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
    const offset = date.getTimezoneOffset() / 60;
    const hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate;
}

export default function formatDate(date, locale) {
    let dt = format(new Date(date), DATE_FORMATS[locale]);
    dt = convertUTCDateToLocalDate(new Date(dt));
    return format(new Date(dt), DATE_FORMATS[locale]);
}
